import React, { useState, useEffect } from 'react';
import { CardHeader, CardContent, CardActions, Grid } from '@mui/material';
import MofService from '../../../../services/mof';
import { Select, Modal } from 'antd';
import { CODES } from '../../../../utils/responseCodes';
import { Box } from '@mui/system';

const { Option } = Select;

const ChooseQuestion = (props) => {
  const { open, handleClose, setOpenModalLoader, preguntasMof, setPreguntasMof, setTitleModalLoader, searchValueListarMof, infoCompany, infoClient, infoPuesto,
    infoEstado, infoConformidad } = props;

  const [archivadoValue, setArchivadoValue] = useState(0);
  const [selected, setSelected] = useState([]);
  const cleanInfo = () => {
    setSelected([]);
    handleClose();
    setPreguntasMof(null);
  }

  const exportMofMassive = async (searchValueListarMof, infoCompany, infoClient, infoPuesto, infoEstado, infoConformidad, archivadoValue, selected) => {
    try {
      setTitleModalLoader('Generando MOF en excel...');
      setOpenModalLoader(true);
      const result = await MofService.exportMofMassive(searchValueListarMof, infoCompany, infoClient, infoPuesto, infoEstado, infoConformidad, archivadoValue, selected);
      if (result.status === CODES.SUCCESS_200) {
        const blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = "LISTA DE MOFS.xlsx";
        link.click();
        URL.revokeObjectURL(url);
        setOpenModalLoader(false);
      } else {
        setOpenModalLoader(false);
        setTitleModalLoader(null);
      }
    } catch (error) {
      console.log(`Error en generateSede: ${error}`);
    }
  }

  return (
    <Modal
      title={
        <CardHeader
          title={'Exportar Personalizado'}
          subheader={'Seleccione campos'}
          sx={{
            paddingBottom: '0.3rem',
            paddingTop: 0,
            margin: '-0.5rem -1rem -0.1rem -1rem',
            borderBottom: `solid 0.05rem #D5DBDB`,
          }}
        />
      }
      open={open}
      onOk={cleanInfo}
      onCancel={cleanInfo}
      destroyOnClose={true}
      footer={null}
      style={{ top: '10%' }}
      width={'70%'}
    >
      <Box sx={{ overflow: 'scroll', p: 2 }}>
        <form>
          <CardContent
            sx={{
              padding: 0,
              margin: '0 -0.5rem',
            }}
          >

            {/* Botones de acción */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center', 
                justifyContent: 'end',
                gap: 2,
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <label style={{ fontWeight: "bold", marginRight: "0.5rem" }}>Estado:</label>
                <Select
                  style={{ width: 150 }}
                  size="medium"
                  className="select"
                  mode="single"
                  popupClassName="my-drop-down"
                  value={archivadoValue}
                  onChange={(value) => setArchivadoValue(value)}
                >
                  <Option value={0}>No Archivado</Option>
                  <Option value={1}>Archivado</Option>
                </Select>
              </Box>

              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => setSelected(preguntasMof.map((p) => p.id_preguntamof))}
              >
                Seleccionar todo
              </button>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() => setSelected([])}
              >
                Deseleccionar todo
              </button>
            </Box>

            {/* Checkboxes en 2 columnas */}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)', // 2 columnas
                gap: 2,
                maxHeight: '300px',
                overflowY: 'auto',
                padding: '0.5rem',
              }}
            >
              {preguntasMof?.map((pregunta) => (
                <label
                  key={pregunta.id_preguntamof}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    textTransform: 'uppercase', // Mayúsculas
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selected.includes(pregunta.id_preguntamof)}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setSelected((prev) =>
                        checked
                          ? [...prev, pregunta.id_preguntamof]
                          : prev.filter((id) => id !== pregunta.id_preguntamof)
                      );
                    }}
                  />
                  {pregunta.descripcion}
                </label>
              ))}
            </Box>
          </CardContent>

          <CardActions
            sx={{
              margin: '0.5rem -1rem -1rem -1rem',
              borderTop: `solid 0.05rem #00337C`,
            }}
          >
            <button
              type={'button'}
              onClick={() =>
                exportMofMassive(
                  searchValueListarMof,
                  infoCompany,
                  infoClient,
                  infoPuesto,
                  infoEstado,
                  infoConformidad,
                  archivadoValue,
                  selected
                )
              }
              className="btn btn-success btn-sm"
              style={{ fontSize: '15px' }}
            >
              Exportar
            </button>
            <button
              type={'button'}
              onClick={cleanInfo}
              className="btn btn-danger btn-sm"
              style={{ fontSize: '15px' }}
            >
              Cerrar
            </button>
          </CardActions>
        </form>
      </Box>
    </Modal>
  );
};


export default ChooseQuestion;